import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

//ICONS
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
   textField: {
      width: '100%'
   },
   marginAuxT: {
      marginTop: theme.spacing(1)
   },
   marginAuxR: {
      marginRight: theme.spacing(1)
   },
   marginAuxL: {
      marginLeft: theme.spacing(1)
   },
   marginIcon: {
      margin: theme.spacing(0.5)
   },
   borderTop: {
      borderTop: `1px solid #bcbdbf`
   },
   aux: {
      backgroundColor: 'red'
   }
}));

function DatosAdicionalesAgregar(props) {
   const classes = useStyles();
   const {
      titulo,
      campoObligatorio,
      infoSugerida,
      columnasDatosAdicionales,
      procesarDatosAdicionales,
      errorValidacion,
      closeModalCallback,
      closeModal,
      cancelarClick,
      objetoActual
   } = props;

   const [options, setOptions] = useState([]);
   /*
   Estados de control
   */
   const [value, setValue] = useState({value: ''});
   const [clave, setClave] = useState('');
   const [valor, setValor] = useState('');
   const [verDatosAdicionales, setVerDatosAdicionales] = useState(
      objetoActual != null && Object.keys(objetoActual).length > 1
   );

   //Cargar estados desde propiedades
   useEffect(() => {
      async function cargarPropiedadesAsync() {
         if (infoSugerida.length > 0) {
            const newOptions = await infoSugerida.map(item => ({value: item}));
            setOptions(newOptions);
         }
      }
      cargarPropiedadesAsync();
      if (objetoActual && objetoActual !== null && objetoActual !== undefined) {
         setDatosAdicionales(objetoActual);
      }
   }, [infoSugerida, objetoActual]);

   /*
   Estados de datos
   */
   const [datosAdicionales, setDatosAdicionales] = useState({[campoObligatorio.name]: ''});

   async function agregarDatosAdicionales() {
      setDatosAdicionales({...datosAdicionales, [clave]: valor});
      const newOptions = options.filter(item => item.value !== clave);
      setOptions(newOptions);
      setClave('');
      setValor('');
   }

   async function editarDatosAdicionales(event) {
      const claveDatoAdicional = event.currentTarget.name;
      setClave(claveDatoAdicional);
      setValor(datosAdicionales[claveDatoAdicional]);
   }

   async function eliminarDatosAdicionales(event) {
      const claveDatoAdicional = event.currentTarget.name;
      setOptions([...options, {value: claveDatoAdicional}]);
      const newDatosAdicionales = datosAdicionales;
      delete newDatosAdicionales[claveDatoAdicional];
      setDatosAdicionales(newDatosAdicionales);
   }

   function handleOnChangeObligatorio(event) {
      setDatosAdicionales({...datosAdicionales, [campoObligatorio.name]: event.target.value});
   }

   function handleOnchageValor(event) {
      setValor(event.target.value);
   }

   function onClickAceptar() {
      if (datosAdicionales[campoObligatorio.name] !== '') {
         if (closeModalCallback) {
            closeModalCallback(datosAdicionales);
         }
         if (procesarDatosAdicionales) {
            procesarDatosAdicionales(datosAdicionales);
         }
      } else {
         const errMsg = `El campo ${campoObligatorio.label} es obligatorio.`;
         if (errorValidacion) {
            errorValidacion(errMsg);
         } else {
            console.log(errMsg);
         }
      }
   }
   function onClickCancelar() {
      if (closeModal) {
         closeModal();
      } else {
         setValue({value: ''});
         setClave('');
         setValor('');
         setDatosAdicionales({[campoObligatorio.name]: ''});
      }
      if (cancelarClick) {
         cancelarClick();
      }
   }

   function handleChecked(event) {
      setVerDatosAdicionales(event.target.checked);
      setDatosAdicionales({
         [campoObligatorio.name]: datosAdicionales[campoObligatorio.name]
      });
   }

   return (
      <Grid container item xs={12} spacing={1}>
         <Grid item xs={12}>
            <Typography variant="h5" className={clsx(classes.marginAuxL, classes.marginAuxT)}>
               {titulo}
            </Typography>
         </Grid>
         <Grid className={clsx(classes.borderTop)} item xs={12}>
            <TextField
               autoFocus
               label={campoObligatorio.label}
               name={campoObligatorio.name}
               value={datosAdicionales[campoObligatorio.name]}
               onChange={handleOnChangeObligatorio}
               className={clsx(classes.textField)}
               margin="dense"
               variant="outlined"
               error={datosAdicionales[campoObligatorio.name] === ''}
               helperText="Este campo es obligatorio."
            />
         </Grid>
         <Grid className={clsx(classes.borderTop)} item xs={12}>
            <Typography className={clsx(classes.marginAuxL, classes.marginAuxT)}>
               Datos Adicionales:{' '}
               {
                  <Checkbox
                     color="primary"
                     inputProps={{'aria-label': 'checkbox datos adicionales'}}
                     checked={verDatosAdicionales}
                     onChange={handleChecked}
                  />
               }
            </Typography>
         </Grid>
         {verDatosAdicionales && (
            <>
               <Grid container item xs={12} spacing={1}>
                  <Grid item xs={4}>
                     <Autocomplete
                        clearText="limpiar"
                        value={value}
                        onChange={(event, newValue) => {
                           setValue(newValue);
                        }}
                        inputValue={clave}
                        onInputChange={(event, newInputValue) => {
                           setClave(newInputValue);
                        }}
                        disabled={datosAdicionales[campoObligatorio.name] === ''}
                        freeSolo
                        name={columnasDatosAdicionales[0]}
                        options={options}
                        getOptionLabel={option => (option === '' ? '' : option.value)}
                        renderInput={params => (
                           <TextField
                              {...params}
                              label={columnasDatosAdicionales[0]}
                              variant="outlined"
                              margin="dense"
                              error={datosAdicionales[campoObligatorio.name] === ''}
                              helperText={
                                 datosAdicionales[campoObligatorio.name] === ''
                                    ? `El campo ${campoObligatorio.label} obligatorio.`
                                    : ''
                              }
                           />
                        )}
                     />
                  </Grid>
                  {/*
                        error={datosAdicionales[campoObligatorio.name] === '' || clave === ''}
                        helperText={
                           datosAdicionales[campoObligatorio.name] === '' || clave === ''
                              ? `Los campos ${campoObligatorio.label} y ${columnasDatosAdicionales[0]} son obligatorios.`
                              : ''
                        }*/}
                  <Grid item xs={7}>
                     <TextField
                        name={columnasDatosAdicionales[1]}
                        variant="outlined"
                        label={columnasDatosAdicionales[1]}
                        value={valor}
                        onChange={handleOnchageValor}
                        margin="dense"
                        disabled={datosAdicionales[campoObligatorio.name] === '' || clave === ''}
                     />
                  </Grid>
                  <Grid container item xs={1} justify="flex-end" alignItems="center">
                     <IconButton
                        onClick={agregarDatosAdicionales}
                        aria-label="agregar informacion adicional"
                        className={clsx(classes.marginIcon)}
                        disabled={
                           datosAdicionales[campoObligatorio.name] === '' ||
                           clave === '' ||
                           valor === ''
                        }
                     >
                        <AddCircleOutlineIcon />
                     </IconButton>
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <TableContainer component={Paper}>
                     <Table size="small" aria-label="Tabla datos adicionales">
                        <TableHead>
                           <TableRow>
                              {columnasDatosAdicionales.map((item, index) => (
                                 <TableCell key={index} align="left">
                                    {item}
                                 </TableCell>
                              ))}
                              <TableCell align="right">Acciones</TableCell>
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {Object.keys(datosAdicionales).map(item => {
                              if (item !== campoObligatorio.name) {
                                 return (
                                    <TableRow key={item}>
                                       <TableCell>{item}</TableCell>
                                       <TableCell>{datosAdicionales[item]}</TableCell>
                                       <TableCell align="right">
                                          <IconButton
                                             onClick={editarDatosAdicionales}
                                             aria-label="editar dato adicional"
                                             className={clsx(classes.marginIcon)}
                                             name={item}
                                             size="small"
                                          >
                                             <EditIcon />
                                          </IconButton>
                                          <IconButton
                                             onClick={eliminarDatosAdicionales}
                                             aria-label="eliminar dato adicional"
                                             className={clsx(classes.marginIcon)}
                                             size="small"
                                             name={item}
                                          >
                                             <DeleteIcon />
                                          </IconButton>
                                       </TableCell>
                                    </TableRow>
                                 );
                              } else {
                                 return null;
                              }
                           })}
                        </TableBody>
                     </Table>
                  </TableContainer>
               </Grid>
            </>
         )}
         <Grid
            className={clsx(classes.marginAuxT, classes.borderTop)}
            container
            item
            xs={12}
            spacing={1}
            justify="flex-end"
         >
            <Button
               className={clsx(classes.marginAuxR)}
               size="small"
               color="secondary"
               onClick={onClickCancelar}
            >
               Cancelar
            </Button>
            <Button
               className={clsx(classes.marginAuxL)}
               variant="contained"
               size="small"
               color="primary"
               onClick={onClickAceptar}
            >
               Aceptar
            </Button>
         </Grid>
      </Grid>
   );
}

DatosAdicionalesAgregar.propTypes = {
   /** Objeto con la información sobre el dato adicional obligatorio, name representa el nombre del objeto y label sera el texto con el que se muestra al usuario. */
   campoObligatorio: PropTypes.exact({name: PropTypes.string, label: PropTypes.string}),
   /** Opciones de autocompletado para los campos adicionales diferentes del campo obligatorio. */
   infoSugerida: PropTypes.arrayOf(PropTypes.string),
   /** Nombres que se mostraran como titulos de los pares clave-valor de los datos adicionales. */
   columnasDatosAdicionales: PropTypes.arrayOf(PropTypes.string),
   /** Titulo mostrado en la parte superior del componente. */
   titulo: PropTypes.string,
   /** Funcion a ejecutar cuando se hace click en aceptar. Toma un parametro con un objeto el cual contiene los pares clave-valor de los datos especificados. */
   procesarDatosAdicionales: PropTypes.func,
   /** Accion a ejecutar cuando sucede un error de validacion de los campos obligatorios. */
   errorValidacion: PropTypes.func,
   /** Funcion de cierre de modal si el componente es llamado dentro de un modal. */
   closeModal: PropTypes.func,
   /** Accion a ejecutar cuando cuando se hace click en aceptar para cerrar el modal. */
   closeModalCallback: PropTypes.func,
   /** Accion a ejecutar cuando se hace click en cancelar. */
   cancelarClick: PropTypes.func,
   /** Objeto con los pares clave-valor que se desean mostrar para su edicion.*/
   objetoActual: PropTypes.object
};

DatosAdicionalesAgregar.defaultProps = {
   titulo: 'Agregar Datos Adicionales',
   campoObligatorio: {name: 'foo0', label: 'Foo0Label'},
   infoSugerida: ['foo1', 'foo2', 'foo3', 'foo4'],
   columnasDatosAdicionales: ['Clave', 'Valor']
};
export default DatosAdicionalesAgregar;
